import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import pick from 'lodash/pick';
import has from 'lodash/has';
import get from 'lodash/get';
import set from 'lodash/set';
import includes from 'lodash/includes';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
import Account, { SignUp } from 'modules/Account';
import { LogoLayout, LogoMobileLayout } from 'modules/Layout';
import App from 'modules/App';
async function action({ route, query, store, getUrl, bls }) {
    let Component = null;
    let redirect = null;
    const returnUrl = get(query, 'ReturnUrl');
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        let identityRequirements = {};
        let identityDefaults = {};
        let blsKey;
        let clientId;
        if (query.identityRequirements) {
            const base64Encoded = query.identityRequirements;
            try {
                identityRequirements = JSON.parse(atob(base64Encoded));
                const { blsReturnUrl, enrollCode, invitationCode } = identityRequirements;
                if (blsReturnUrl) SessionStorage.setItem('hardBlsReturnUrl', blsReturnUrl);
                if (enrollCode) SessionStorage.setItem('enrollCode', enrollCode);
                if (invitationCode) SessionStorage.setItem('invitationCode', invitationCode);
            } catch (err) {
                console.error('base64Encoded', base64Encoded);
            }
        } else if (returnUrl) {
            const url = new URL(returnUrl);
            const prompt = url.searchParams.get('prompt');
            if (prompt === 'create') {
                const initAuthCreateJson = SessionStorage.getItem('initAuthCreate');
                if (initAuthCreateJson) {
                    SessionStorage.removeItem('initAuthCreate');
                }
                const initAuthCreate = JSON.parse(initAuthCreateJson || '{}');
                identityDefaults = initAuthCreate.identityDefaults;
                identityRequirements = initAuthCreate.identityRequirements;
            }
        }
        if (!user) {
            if (SessionStorage.getItem('invitationToken')) {
                try {
                    await store.dispatch(Account.actions.setInvitation());
                } catch (err) {
                // handle in saga
                }
            } else if (SessionStorage.getItem('hardBlsReturnUrl')) {
                const url = new URL(SessionStorage.getItem('hardBlsReturnUrl'));
                clientId = url.searchParams.get('client_id');
                const clientAppKey = clientId.split('-')[0];
                if (has(bls, clientAppKey)) {
                    blsKey = clientAppKey;
                }
            }
            const url = returnUrl && new URL(returnUrl);
            const identityScopeRequirement = url && url.searchParams.get('identityScopeRequirement');
            if (includes(Account.constants.SCOPE_NAMES, identityScopeRequirement)) {
                set(identityRequirements, 'scope', identityScopeRequirement);
            }
            const identityCountryCodeDefault = url && url.searchParams.get('identityCountryCodeDefault');
            if (identityCountryCodeDefault) {
                const countryCode = identityCountryCodeDefault.toLowerCase();
                const selector = App.selectors.countryByAlpha2Code(countryCode);
                const country = selector(store.getState());
                if (country && !includes(identityRequirements, 'countryCode')) {
                    set(identityDefaults, 'countryCode', countryCode);
                }
            }
            const appSKUCountryCode = url && url.searchParams.get('appSKUCountryCode');
            if (appSKUCountryCode) {
                const countryCode = appSKUCountryCode.toLowerCase();
                set(identityDefaults, 'appSKUCountryCode', countryCode);
            }
            clientId = clientId || url && url.searchParams.get('client_id');
            if (clientId) {
                try {
                    await store.dispatch(App.actions.fetchClient(clientId)).catch(()=>{});
                } catch (err) {
                // handle in saga
                }
            }
            Component = /*#__PURE__*/ _jsx(SignUp, {
                identityRequirements: pick(identityRequirements, [
                    'countryCode',
                    'appSKUCountryCode',
                    'email',
                    'scope'
                ]),
                identityDefaults: identityDefaults,
                blsKey: blsKey,
                returnUrl: returnUrl
            });
        } else {
            redirect = getUrl('app-catalog');
        }
    }
    const isMobileDisplayMode = App.selectors.isMobileDisplayMode(store.getState());
    const CurrentLayout = isMobileDisplayMode ? LogoMobileLayout : LogoLayout;
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: /*#__PURE__*/ _jsx(CurrentLayout, {
            children: Component
        })
    };
}
export default action;
